import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../common/formik/FormikButton';
import FormikGrid from '../../common/formik/FormikGrid';
import FormikTextField from '../../common/formik/FormikTextField';
import { useCreateUser } from '../../user/User.hooks';
import { User } from '../../user/User.interface';

export interface UserCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (user: User) => void;
}

const UserCreateDialog: React.FC<UserCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const { user, isLoading, error, post } = useCreateUser();
  useEffect(() => {
    if (!isLoading) {
      if (onCreated && user) {
        onCreated(user);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [isLoading, onCreated, user]);
  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ firstName: '', lastName: '', email: '', password: '' }}
        validationSchema={Yup.object({
          firstName: Yup.string().required('Required'),
          lastName: Yup.string().required('Required'),
          email: Yup.string().email().required('Email is Required.')
        })}
        onSubmit={(userDto: Partial<User>) => {
          post(userDto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>New User</DialogTitle>
          <DialogContent>
            <DialogContentText>Personal Information</DialogContentText>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='firstName'
                label='First Name'
              />
              <FormikTextField type='text' name='lastName' label='Last Name' />
              <FormikTextField type='text' name='email' label='Email' />
            </FormikGrid>

            {error && (
              <Alert severity='error'>
                {error.message ||
                  'Error occurred. Please check your internet connection and try again.'}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default UserCreateDialog;
